import { render, staticRenderFns } from "./FTNews.vue?vue&type=template&id=20997de8&lang=pug"
import script from "./FTNews.vue?vue&type=script&lang=js"
export * from "./FTNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports